<template>
  <div id="app">
    <el-card style="padding: 20px; box-sizing: border-box; min-height: 850px">
      <div>
        <span class="basisInformation">公告管理</span>
        <add-notice
          style="display: inline-block; float: right"
          v-if="roleId == '-1004'"
          @updateData="updateList"
        ></add-notice>
      </div>
      <el-divider></el-divider>
      <el-tabs v-model="activeName" @tab-click="tabClick">
        <el-tab-pane label="全部公告" name="1"></el-tab-pane>
        <el-tab-pane label="已发公告" name="2"></el-tab-pane>
      </el-tabs>
      <div>
        <!-- 全部公告 -->
        <template v-if="activeName === '1'">
          <el-card class="quanbu" v-for="item in noticeLists" :key="item.id">
            <div @click="clickDrawer(item.id)">
              <p style="margin-top: 10px; vertical-align: top">
                <el-tag type="success" size="mini">{{
                  item.types == 0 ? '普通公告' : '质疑公告'
                }}</el-tag>
                <el-badge is-dot :hidden="item.readed">
                  <span style="font-size: 17px; margin-left: 20px">{{
                    item.title
                  }}</span>
                </el-badge>
              </p>
              <p style="margin-top: 15px; font-size: 15px">{{ item.author }}</p>
              <p style="margin-top: 15px">{{ item.createTime }}</p>
            </div>
          </el-card>
          <!-- 分页 -->
          <el-pagination
            v-if="noticeLists.length"
            background
            layout="prev, pager, next, jumper"
            @current-change="currentChange"
            :hide-on-single-page="true"
            :total="page.totalCount"
          ></el-pagination>
          <p style="text-align: center" v-if="!noticeLists.length">
            暂无公告信息
          </p>
        </template>
        <!-- 自己已发公告 -->
        <template v-if="activeName === '2'">
          <el-card class="quanbu" v-for="item in noticeListsY" :key="item.id">
            <div @click="clickDrawer(item.id)">
              <p style="margin-top: 10px; vertical-align: top">
                <el-tag type="success" size="mini">{{
                  item.types == 0 ? '普通公告' : '质疑公告'
                }}</el-tag>
                <el-badge is-dot :hidden="item.readed">
                  <span style="font-size: 17px; margin-left: 20px">{{
                    item.title
                  }}</span>
                </el-badge>
              </p>
              <p style="margin-top: 15px; font-size: 15px">{{ item.author }}</p>
              <p style="margin-top: 15px">{{ item.createTime }}</p>
            </div>
            <el-button
              type="primary"
              size="small"
              class="ybtn"
              @click="deleteNotice(item.id)"
              >删除公告</el-button
            >
          </el-card>
          <!-- 分页 -->
          <el-pagination
            v-if="noticeListsY.length"
            background
            layout="prev, pager, next, jumper"
            @current-change="currentChangeY"
            :hide-on-single-page="true"
            :total="pageY.totalCount"
          ></el-pagination>
          <p style="text-align: center" v-if="!noticeListsY.length">
            暂无公告信息
          </p>
        </template>
      </div>
    </el-card>

    <!-- 公告详情 -->
    <el-drawer
      :title="drawerList.title"
      :visible.sync="drawer"
      :show-close="true"
    >
      <div class="drawer" :style="{ height: height + 'px' }">
        <div style="margin-bottom: 20px">
          <span>发布者：{{ drawerList.author }}</span>
          <span style="margin-left: 20px"
            >时间：{{ drawerList.createTime }}</span
          >
        </div>
        <div class="textgonggao" v-html="drawerList.content"></div>
        <div>
          <a
            v-for="item in drawerList.attactList"
            :key="item.id"
            :href="item.link"
            :download="item.title"
            >{{ item.title }}</a
          >
        </div>
        <div>
          <img
            v-for="item in drawerList.imgList"
            :key="item.id"
            :src="item.link"
            alt=""
          />
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import addNotice from './components/addNotice'
import {
  noticeList,
  queryNotice,
  noticePubList,
  deleteNotice,
} from '@/api/notice.js'
export default {
  components: {
    addNotice,
  },
  data() {
    return {
      activeName: '1',
      type: '',
      noticeLists: [], //全部公告
      noticeListsY: [], //已发公告
      userId: localStorage.getItem('schoolIds'),
      roleType: localStorage.getItem('roleType'),
      page: {
        pageSize: 10,
        curPage: 1,
        totalCount: 0,
      },
      pageY: {
        pageSize: 10,
        curPage: 1,
        totalCount: 0,
      },
      receiverList: [],
      drawer: false, //抽屉弹窗
      drawerList: [], //公告详情数据
      roleId: 0,
      height: 880,
    }
  },
  created() {
    this.roleId = localStorage.getItem('roleId')
    this.noticeList()
  },
  mounted() {
    window.onresize = () => {
      this.height = document.documentElement.clientHeight - 80
    }
  },
  methods: {
    // tab栏点击切换事件
    tabClick() {
      if (this.activeName === '1') {
        this.noticeList()
      } else {
        this.noticePubList()
      }
    },
    // 获取全部公告
    async noticeList() {
      this.userId = localStorage.getItem('userId')
      const { data: res } = await noticeList({
        userId: this.userId,
        roleType: this.roleType,
        ...this.page,
      })
      this.page.totalCount = res.data.totalCount
      this.noticeLists = res.data.dataList
    },
    // 获取公告详情
    async clickDrawer(id) {
      this.drawer = true
      const { data: res } = await queryNotice(id)
      this.drawerList = res.data
      this.noticeList()
    },
    //获取自己已发公告
    async noticePubList() {
      const { data: res } = await noticePubList({
        userId: this.userId,
        roleType: this.roleType,
        ...this.pageY,
      })
      this.pageY.totalCount = res.data.totalCount
      this.noticeListsY = res.data.dataList
    },
    // 页码变化
    currentChange(e) {
      this.page.curPage = e
      this.noticeList()
    },
    currentChangeY(e) {
      this.pageY.curPage = e
      this.noticePubList()
    },
    // 删除我发布的公告
    async deleteNotice(id) {
      const confirResult = await this.$confirm(
        '此操作将删除该公告, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).catch((err) => err)
      if (confirResult !== 'confirm') {
        return this.$message.info('已取消删除！！')
      }
      const { data: res } = await deleteNotice(id, {
        userId: this.userId,
        roleType: this.roleType,
        id: id,
      })
      this.noticePubList()
    },
    // 刷新公告
    updateList() {
      this.noticeList()
      this.noticePubList()
    },
  },
}
</script>
<style scoped>
.el-card {
  margin: 0 auto;
  width: 1440px;
  min-height: 162px;
}

.basisInformation {
  font-size: 16px;
  font-weight: 700;
  margin-top: 10px;
}
.quanbu {
  cursor: pointer;
  height: 135px;
  width: 1360px;
  margin-bottom: 10px;
  position: relative;
}
.drawer {
  margin: 0 20px;
}

.ybtn {
  position: absolute;
  top: 68px;
  right: 150px;
}
.el-divider {
  margin-top: 18px;
  margin-bottom: 8px;
}
.drawer img {
  width: 100%;
}

.ql-align-center {
  width: 100%;
  display: inline-block;
  text-align: center;
}

.el-drawer__body {
  height: 100%;
}

.drawer {
  max-height: 880px;
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/school/Notice.vue